import * as React from 'react'

import { TimePicker as TimePickerPresenter, IProps } from './presenter'

export const TimePicker = (props: IProps): JSX.Element => {
  return <TimePickerPresenter {...props} />
}

export default TimePicker
